export default "__VITE_ASSET__7cf79572__"